import { useState } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Modal, ModalActions, ModalContent, Button, UpliftThemeProvider } from '@uplift/ui-v2';
import { ModalEnum } from '@uplift/types';
import { useL10n, useStore } from '@uplift/hooks';


const useStyles = makeStyles()({
  paperWidthSm: {
    maxWidth: '600px'
  }
});


export const CongratsModal = () => {
  const l10n = useL10n();
  const { classes } = useStyles();
  const { modalStore } = useStore();
  const [ isOpen, setOpen ] = useState(modalStore.modals[ModalEnum.congratulation] ?? false);

  const closeHandler = () => {
    modalStore.closeModal(ModalEnum.congratulation);
    setOpen(false);
  };

  return (
    <UpliftThemeProvider>
      <Modal
        classes={classes}
        open={isOpen}
        onClose={closeHandler}
        title={l10n.profile.congratsComplete.title}
        maxWidth="sm"
        fullWidth
      >
        <ModalContent>
          <Typography>{l10n.profile.congratsComplete.details}</Typography>
        </ModalContent>

        <ModalActions>
          <Button
            color="secondary"
            variant="contained"
            onClick={closeHandler}
            href="https://joinuplift.typeform.com/to/jbFfLUtb"
          >
            {l10n.profile.congratsComplete.startYourTraining}
          </Button>
        </ModalActions>
      </Modal>
    </UpliftThemeProvider>
  );
};
